import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Card, CardBody, Container, Spinner } from 'reactstrap';
import useGet from '../../helpers/hooks/useGet';
import MundiAds from './mundi-ads';
import useGetAuthed from '../../helpers/hooks/useGetAuthed';
import { MDBPageItem, MDBPageNav } from 'mdbreact';

function Mundi() {
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Adjust as needed
  const pagesAmount = 250; // Setting pages amount to 100

  const [error, setError] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const handleNext = () => {
    if (currentPage < pagesAmount) setCurrentPage(currentPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  const call = async (offset) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/${`seller-ads?filter=${encodeURIComponent(
          JSON.stringify({
            order: 'createdAt DESC',
            limit: itemsPerPage,
            offset: offset,
            include: [{ relation: 'farmer' }, { relation: 'vegetable' }, { relation: 'district' }],
          })
        )}`}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(localStorage.getItem('bankAdmin'))
                ? JSON.parse(localStorage.getItem('bankAdmin')).data?.token
                : JSON.parse(localStorage.getItem('authUser')).data?.token
            }`,
          },
        }
      );
      console.log(JSON.parse(localStorage.getItem('loanAuth')));
      console.log(JSON.parse(localStorage.getItem('bankAdmin')));
      console.log(JSON.parse(localStorage.getItem('authUser')));

      const result = await response.json();
      if (response.ok) {
        setData(result);
      } else {
        setError(result);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentPage === 1) {
      call(currentPage - 1);
    } else {
      call((currentPage - 1) * 10);
    }
  }, [currentPage]);

  // const [data, error, loading, call] = useGetAuthed(
  //   `/seller-ads?filter=${encodeURIComponent(
  //     JSON.stringify({
  //       order: 'createdAt DESC',
  //       include: [
  //         { relation: 'farmer' },
  //         { relation: 'vegetable' },
  //         { relation: 'district' },
  //       ],
  //     })
  //   )}`,
  //   true
  // );
  const handleViewBids = (ad) => {
    history.push(`/mundi-bids/${ad.id}`);
  };

  // Create pagination range
  const pageNumbers = [];
  for (let i = 1; i <= pagesAmount; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    if (
      number === 1 ||
      number === pagesAmount ||
      (number >= currentPage - 1 && number <= currentPage + 1)
    ) {
      return (
        <MDBPageItem active={number === currentPage} key={number}>
          <MDBPageNav onClick={() => handlePageClick(number)} className="page-link-custom">
            {number}
          </MDBPageNav>
        </MDBPageItem>
      );
    } else if (number === currentPage - 2 || number === currentPage + 2) {
      return (
        <MDBPageItem key={number}>
          <MDBPageNav className="page-link-custom">...</MDBPageNav>
        </MDBPageItem>
      );
    }
    return null;
  });

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <div className="align-items-end d-flex justify-content-between mb-3">
            <h4>Marketplace - Mundi</h4>
            {/* <Link to='/system/add-new-advisory-stat'>
              <Button
                color='primary'
                outline
                type='button'
                size='sm'
                className='waves-effect waves-light'
              >
                Add New Advisory Stat{' '}
                <i className='mdi mdi-plus align-middle ml-2'></i>
              </Button>
            </Link> */}
          </div>
          <Card>
            <CardBody>
              {loading ? (
                <div className="text-center">
                  <Spinner className="mr-2" color="primary" />
                </div>
              ) : (
                <MundiAds
                  ads={data}
                  viewBids={handleViewBids}
                  currentPage={currentPage}
                  handlePrev={handlePrev}
                  renderPageNumbers={renderPageNumbers}
                  pagesAmount={pagesAmount}
                  handleNext={handleNext}
                ></MundiAds>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
}

export default Mundi;
